import script from "./ModelControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelControl.vue?vue&type=script&setup=true&lang=js"

import "./ModelControl.vue?vue&type=style&index=0&id=5fa13c42&scoped=true&lang=scss"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa13c42"]])

export default __exports__